import React from "react";

import { Divider, Space, Switch, Select, DatePicker } from "antd";

import moment from "moment";

const { RangePicker } = DatePicker;
const dateFormat = "DD/MM/YYYY";

const Filters = (props) => {
    const { filters } = props;

    const vendor = filters ? (filters.vendor ? parseInt(filters.vendor) : undefined) : undefined;
    const clientId = filters ? (filters.clientId ? parseInt(filters.clientId) : undefined) : undefined;
    const project = filters ? (filters.project ? parseInt(filters.project) : undefined) : undefined;
    const pointOfSale = filters ? (filters.pointOfSale ? parseInt(filters.pointOfSale) : undefined) : undefined;
    const financeDateMin = filters
        ? filters.financeDateMin
            ? moment(filters.financeDateMin, dateFormat)
            : undefined
        : undefined;
    const financeDateMax = filters
        ? filters.financeDateMax
            ? moment(filters.financeDateMax, dateFormat)
            : undefined
        : undefined;

    const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    const updateRange = (e, a) => {
        if (e) {
            props.onUpdateFilters({ financeDateMin: a[0], financeDateMax: a[1] });
        } else {
            props.onUpdateFilters({ financeDateMin: undefined, financeDateMax: undefined });
        }
    };

    return (
        <>
            <Space size="small">
                Range:
                <RangePicker
                    size="small"
                    defaultValue={[financeDateMin, financeDateMax]}
                    format={dateFormat}
                    name="range"
                    onChange={updateRange}
                />
            </Space>
            <br />
            <br />
            <Space size="small">
                Filtros:
                <Select
                    placeholder="Vendor"
                    allowClear
                    name="Vendor"
                    size="small"
                    showSearch
                    options={props.vendors}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={vendor}
                    onChange={(e) => {
                        props.onUpdateFilters({ vendor: e ? e : undefined });
                    }}
                />
                <Select
                    placeholder="Client"
                    allowClear
                    name="Client"
                    size="small"
                    showSearch
                    options={props.clients}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={clientId}
                    onChange={(e) => {
                        props.onUpdateFilters({ clientId: e ? e : undefined });
                    }}
                />
                <Select
                    placeholder="Project"
                    allowClear
                    name="Project"
                    size="small"
                    showSearch
                    options={props.projects}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={project}
                    onChange={(e) => {
                        props.onUpdateFilters({ project: e ? e : undefined });
                    }}
                />
                <Select
                    placeholder="Point Of Sale"
                    allowClear
                    name="pointOfSale"
                    size="small"
                    showSearch
                    options={props.pointsOfSale}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={pointOfSale}
                    onChange={(e) => {
                        props.onUpdateFilters({ pointOfSale: e ? e : undefined });
                    }}
                />
            </Space>
        </>
    );
};

export default Filters;
